import React from "react";

function Recruiting() {
  return <div>Recruiting</div>;
}

export default Recruiting;
